import Transfer from "manifest-components/src/classes/transfer";
import TransferSource from "manifest-components/src/classes/transferSource";
import TransferOptions from "manifest-components/src/classes/transferOptions";
import TransferDestination from "manifest-components/src/classes/transferDestination";
import TransferInstruction from "manifest-components/src/classes/transferInstruction";

export const TransferState = {
  transferInstructionsWithUserInputNeeded: [] as TransferInstruction[],
  transferInstructionsWithUserInputNeededFetched: false,
  completeTransfers: [] as TransferInstruction[],
  completeTransfersFetched: false,
  cancelledTransfers: [] as TransferInstruction[],
  providersList: [] as { label: string; value: string }[],
  providersListFetched: false,
  connectingManualAccount: false,
  manualAccountConnected: false,
  cancelledTransfersFetched: false,
  currentTransfer: new Transfer(),
  currentTransferFetched: false,
  fetchingTransferredDestinations: false,
  transferInstructionsWithIRAOpening: [] as TransferInstruction[],
  iraOptions: [] as {
    accountOpeningUrl: string;
    body: {
      content: string;
      header: string;
    }[];
    iraProviderName: string;
    subtitle: string[];
    title: string;
  }[],
  updatedAccountsAfterLink: false,
  fetchingProvidersList: false,

  fetchingTransferOptions: false,
  transferOptionsFetched: false,
  transferOptions: new TransferOptions(),
  providerMailingDetails: {},
  mailingDetailsFetched: false,
  currentPlanData: {} as TransferSource | TransferDestination,
  fetchingPlanData: false,
  planDataFetched: false,
  dataRemoved: false,
  destinationConnectedToTransfer: false,
  iraOpeningOptionConnected: false,
  inProgressTransfers: [] as Transfer[],
  inProgressTransfersFetched: false,
  fetchingCurrentTransfer: false,
  fetchingTransferInstructions: false,
  fetchingCancelledTransfers: false,
  fetchingCompletedTransfers: false,
  fetchingInitiatedTransfers: false,
  fetchingInProgressTransfers: false,
  initiatedTransfers: [] as TransferInstruction[],
  initiatedTransfersFetched: false,
  queuedTransfers: [] as TransferInstruction[],
  queuedTransferFetched: false,
  statementAccounts: [] as { editable: boolean; statementAccountId: string }[],
  statementAccountsFetched: false,
  statementAccountsConnected: false,
  loadingTransfer: true,
  showAllTransfers: true,
  statementUrl: "",
  statementUrlFetched: false,
  rothTransferredDestinations: {},
  transferDataRemoved: false,
  rothTransferredDestinationsFetched: false,
  transferredDestinations: [] as TransferDestination[],
  transferredDestinationsFetched: false,
  statementFiles: [] as string[],
  statementFilesFetched: false,
  statementAccountsRemoved: false,
  statementUrlRemoved: false,

  // Transfer Source Properties
  transferSourcesUpdating: false,

  // Transfer Destination Properties
  transferDestinationFetched: false,
  transferDestinationFetching: false,
  transferDestinationUpdating: false,
  transferDestination: {} as TransferDestination,
};
